import leadsService from "services/leadsService";

export const LEADS_FETCH = "@leads/fetch";
export const LEADS_FETCH_SUCCESS = "@leads/fetch-success";
export const LEADS_FETCH_FAILURE = "@leads/fetch-failure";

export const SEND_ACK = "@leads/send-ack";
export const SEND_ACK_SUCCESS = "@leads/send-ack-success";
export const SEND_ACK_FAILURE = "@leads/send-ack-failure";

export function fetchLeads(vendorsIn, userId, options = {}) {
  return async (dispatch) => {
    const isPaginated = Boolean(options?.pagination || options?.filters);
    try {
      dispatch({ type: LEADS_FETCH, meta: { isPaginated } });

      const response = await leadsService.fetchLeads(vendorsIn, userId, options);
      const leads = Array.isArray(response) ? response : response?.leads || [];
      const pagination = Array.isArray(response) ? null : response?.pagination || null;
      const counts = Array.isArray(response) ? null : response?.counts || null;

      // console.log("fetchLeads()(after):" + JSON.stringify(leads));
      dispatch({
        type: LEADS_FETCH_SUCCESS,
        payload: {
          leads,
          pagination,
          counts,
        },
        meta: { isPaginated },
      });
    } catch (error) {
      dispatch({ type: LEADS_FETCH_FAILURE, meta: { isPaginated } });
      throw error;
    }
  };
}

export function sendAckLead(supplierId, rfqId, viewByName, viewById, acknowledgeDate) {
  return async (dispatch) => {
    try {
      dispatch({ type: SEND_ACK });

      const acknowledge = await leadsService.sendAckLead(supplierId, rfqId, viewByName, viewById, acknowledgeDate);

      //console.log("fetchLeads()(after):" ,acknowledge);
      // await dispatch(fetchLeads());

      dispatch({
        type: SEND_ACK_SUCCESS,
        payload: {
          acknowledge,
        },
      });



    } catch (error) {
      dispatch({ type: SEND_ACK_FAILURE });
      throw error;
    }
  };
}
